export default __webpack_public_path__ + "static/media/tasksIcon.d4da27b1.svg";